// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.c240-tab-section-height {
    margin-left: 20px;
    padding-left: 10px;
}

.c240-tab-section-height .ant-tabs-ink-bar{
    position: absolute;
    background: #000000;
    pointer-events: none;
 }
 .c240-tab-section-height .ant-tabs-tab.ant-tabs-tab-active{
    color: #000000;
    font-weight: 500;
 }

 .c240-tab-section-height .ant-tabs-nav .ant-tabs-tab:hover {
    color: #000000;
}

.c240-button  {
    color: white !important;
}

.ant-radio-button-wrapper:hover{
    color: black !important;
}

.c240-button .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
    background-color: black !important;
    color: #fff !important;
    border-color: black;
    box-shadow: -1px 0 0 0;
}

.c240-button .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):hover {
    background-color: black;
    color: #fff;
    border-color: black;
    box-shadow: -1px 0 0 0;
}

.c240-save-button-height{
    height:6vh;
    margin-top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/view/c240/c240_general_preview_area_selection.css"],"names":[],"mappings":";AACA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;CACvB;CACA;IACG,cAAc;IACd,gBAAgB;CACnB;;CAEA;IACG,cAAc;AAClB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;IAClC,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB,WAAW;IACX,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,UAAU;IACV,gBAAgB;AACpB","sourcesContent":["\n.c240-tab-section-height {\n    margin-left: 20px;\n    padding-left: 10px;\n}\n\n.c240-tab-section-height .ant-tabs-ink-bar{\n    position: absolute;\n    background: #000000;\n    pointer-events: none;\n }\n .c240-tab-section-height .ant-tabs-tab.ant-tabs-tab-active{\n    color: #000000;\n    font-weight: 500;\n }\n\n .c240-tab-section-height .ant-tabs-nav .ant-tabs-tab:hover {\n    color: #000000;\n}\n\n.c240-button  {\n    color: white !important;\n}\n\n.ant-radio-button-wrapper:hover{\n    color: black !important;\n}\n\n.c240-button .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {\n    background-color: black !important;\n    color: #fff !important;\n    border-color: black;\n    box-shadow: -1px 0 0 0;\n}\n\n.c240-button .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):hover {\n    background-color: black;\n    color: #fff;\n    border-color: black;\n    box-shadow: -1px 0 0 0;\n}\n\n.c240-save-button-height{\n    height:6vh;\n    margin-top: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
